import React from 'react';
import { motion } from 'framer-motion';
import { MindMapCanvas } from '../../components/MindMap';

const ReferralMap = () => {
  return (
    <>
      {/* Full screen canvas that breaks out of parent constraints */}
      <div 
        className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen"
        style={{ zIndex: 0 }}
      >
        <MindMapCanvas mapId="referral" />
      </div>
      {/* Empty placeholder to maintain layout flow */}
      <div className="h-[calc(100vh-120px)]" />
    </>
  );
};

export default ReferralMap;
